import { render, staticRenderFns } from "./OpeningHoursWeekday.vue?vue&type=template&id=32e39eee&scoped=true"
import script from "./OpeningHoursWeekday.vue?vue&type=script&lang=js"
export * from "./OpeningHoursWeekday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e39eee",
  null
  
)

export default component.exports